import { Unit_fetchForTypes } from '../Unit/Unit.fetch'
import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import { getUnitTypesInFlow } from '../../../shared/domain/flows/unit.no-deps'
import { flatten, uniq } from '../../../shared/lib/functional/array.no-deps'
import { pipe } from '../../../shared/lib/functional/pipe.no-deps'
import { IDB_unitTypeRead, IDB_unitTypesReadAll } from '../IDB/IDB.table.unitType'

export async function Flow_fetchUnitsInFlows(flows: Flows.Flow[]) {
    const allUnitTypes = await IDB_unitTypesReadAll()
    const flowUnitTypes = flows.map((flow) => getUnitTypesInFlow(flow, allUnitTypes))
    return pipe(flowUnitTypes, flatten, uniq, Unit_fetchForTypes)
}

export async function Flow_fetchUnitType(id: number) {
    return IDB_unitTypeRead(id)
}
